exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-b8680842]::-webkit-inner-spin-button,input[data-v-b8680842]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-b8680842]{-moz-appearance:textfield}.tdSembunyi[data-v-b8680842]{padding:0!important}", ""]);

// exports
